export const REPORT_DATA_SUCCESS="report/REPORT_DATA_SUCCESS";
export const REPORT_DATA_FAILURE="report/REPORT_DATA_FAILURE";